import { useColorScheme as useReactNativeColorScheme } from 'react-native';
import { useAppSelector } from 'store/hooks';
const useColorScheme = () => {
    const colorScheme = useReactNativeColorScheme();
    const userColorScheme = useAppSelector((store) => store.utils.colorScheme);
    return userColorScheme ?? colorScheme;
};
export default useColorScheme;
